/**
 * mixin
 */
import {enforceFormat, formatToPhone} from "../store/modules/utils";
import {MessageBox} from "element-ui";
import {mapActions, mapMutations, mapState, mapGetters} from "vuex";
import moment from "moment";
const EN_KEY = 'en'
const CH_KEY = 'ch'

// 推荐模块
export const showRecommendedData = {
  methods: {
    getIsNotRecommended(str) {
      str = this.removeAllSpacesAnd2LocaleLowerCase(str)
      const str1 = this.removeAllSpacesAnd2LocaleLowerCase('Recommended For You')
      const str2 = this.removeAllSpacesAnd2LocaleLowerCase('Recommand for you')
      return str !== str1 && str !== str2
    },
    // 去除所有空格并且转小写
    removeAllSpacesAnd2LocaleLowerCase(str) {
      return str.trim().split(' ').join('').toLowerCase()
    }
  },
  computed: {
    showRecommended() {
      const customCategories = JSON.parse(JSON.stringify(this.$store.state.products.customCategories))
      const recommended = customCategories.find(item => {
        return !this.getIsNotRecommended(item.Name)
      })
      if (!recommended || !Array.isArray(recommended.Products)) {
        return [{Products: []}]
      }
      return [{
        ...recommended,
        Products: recommended.Products.reverse().sort(this.outOfStockToEnd)
      }]
    }
  }
}

// 中英文模块
export const locales = {
  computed: {
    // 当前是否是英文版
    curIsEnglish() {
      return this.$i18n.locale === EN_KEY
    },
    // 当前是否是中文版
    curIsChinese() {
      return this.$i18n.locale === CH_KEY
    }
  },
  methods: {
    ...mapMutations('navbar', ['changeLang']),
    langChanged() {
      let localeVal = EN_KEY // 默认当前中文，需要修改成英文
      if (this.curIsEnglish) {
        localeVal = CH_KEY;
      }
      localStorage.Lang = localeVal;
      this.$i18n.locale = localeVal;
      this.changeLang(localeVal);
    }
  }
}

// 已售罄排序模块
export const outOfStockSorts = {
  methods: {
    // 是否是已售罄
    isOutOfStock(item) {
      if (item.IsOverSaleable) {
        return false
      }
      return item.StockLevel <= 0
    },
    // 已售罄的排在最后
    outOfStockToEnd(firstEl, secondEl) {
      const firstIsOutOfStock = this.isOutOfStock(firstEl)
      const secondIsOutOfStock = this.isOutOfStock(secondEl)
      if (!firstIsOutOfStock && secondIsOutOfStock) {
        // 此时是前面的元素不是已售罄，后面的元素是已售罄，已售罄的排在后边
        return -1; // 返回结果小于0，secondEl排在后边
      }
      // 其他情况，排序不变
      return 0; // // 返回结果等于0排序不变
    }
  }
}

// 验证手机号模块
export const validPhone = {
  methods: {
    formatPhone($event) {
      formatToPhone($event, this.checkShippingForm || null)
    },
    formatEnforce($event) {
      enforceFormat($event)
    },
  }
}

// 删除地址模块
export const deleteAddress = {
  methods: {
    openConfirmationDeleteAlert(id, callback, that) {
      MessageBox.confirm('Remove this address from the list?', 'Warning', {
        confirmButtonText: 'OK',
        cancelButtonText: 'CALCEL',
        type: 'warning',
        center: true
      }).then(async () => {
        const isDelSuccess = await this.deleteAddress(id).then(res => {
          return res
        }).catch(err => err)
        if (!isDelSuccess || !callback) {
          return
        }
        if (!that) {
          return callback(id)
        }
        callback.call(that, id)
      }).catch(() => {
      });
    },
    // 删除地址
    deleteAddress(CustomerDetail_id) {
      return this.$store.dispatch('addresses/deleteAddress', CustomerDetail_id)
    }
  }
}

// 去商品详情模块
export const toProductDetail = {
  methods: {
    ...mapMutations('products', ['updateActiveProduct']),
    ...mapMutations('navbar', ['showMobileProductDetailsModal']),
    goToProductDetail(product) {
      this.updateActiveProduct(product.ProductNum);
      if (this.isMobile) {
        return this.showMobileProductDetailsModal()
      }
      this.$router.push({ name: 'productDetails', query: { productNum: product.ProductNum} })
    },
  },
  computed: {
    ...mapState({
      windowWidth: state => state.navbar.windowWidth,
    }),
    isMobile() {
      return this.windowWidth < 800;
    }
  },
}

// 去优惠券列表模块
export const promoCodeList = {
  methods: {
    ...mapActions('profile', ['fetchPromotionData']),
    querySearchPromoCode(queryString, cb) {
      const promotionData = this.promotionData
      if (!queryString) {
        return cb(promotionData)
      }
      const queryStr = queryString.toUpperCase()
      const res = promotionData.filter(({PromoCode}) => {
        return PromoCode && PromoCode.toUpperCase().includes(queryStr)
      })
      if (!res.length) {
        return cb([])
      }
      cb(res);
    },
    getExpireDate(date){
      return moment(date).format('MM/DD/YY');
    },
    getPromoTitle(item) {
      if (item.Method === "ByTotalPriceDiscount") {
        if (item.IsPercent) {
          return item.Off + '% OFF';
        } else {
          return '$' + item.Off + ' OFF';
        }
      } else {
        return 'FREE';
      }
    },
  },
  computed: {
    ...mapState({
      promotionData: state => state.profile.promotionData,
    })
  },
  mounted() {
    this.$nextTick(() => {
      if (this.afm_activated) {// 已经执行过activated钩子
        return
      }
      this.fetchPromotionData()
    })
  },
  activated() {
    this.afm_activated = true
    this.fetchPromotionData()
  }
}

// uni模块
export const uni = {
  computed: {
    ...mapState({
      uni: state => state.uni
    }),
    ...mapGetters(['isApp', 'isIosApp']),
  }
}

// fixed模块
export const fixed = {
  data() {
    return {
      isFixed: false,
      fixedTimeOutId: null,
      count: 0
    }
  },
  methods: {
    initHeight() {
      const {fixedTimeOutId, count} = this
      if (fixedTimeOutId) {
        clearTimeout(fixedTimeOutId)
        count > 30 && this.setIsFixedByOffsetTop()
      }
      this.fixedTimeOutId = setTimeout(this.setIsFixedByOffsetTop, 100)
    },
    setIsFixedByOffsetTop() {
      this.count = 0
      const el = document.getElementById('fixedRef')
      if (!el) return
      const val = el.getBoundingClientRect().top <= 50
      if (this.isFixed === val) return
      this.isFixed = val
    }
  },
  activated() {
    this.isFixed = false
    this.count = 0
    window.addEventListener('scroll', this.initHeight)
  },
  deactivated() {
    window.removeEventListener('scroll', this.initHeight)
  }
}



// WEBPACK FOOTER //
// ./src/mixin/index.js